import React, { useEffect } from "react";
import { useLocation, Navigate, useNavigate } from "react-router-dom";
import { useSubscription } from "../context/SubscriptionProvider";
import { ModuleName } from "../types/subscription";

// accessMap.ts
export const routeModuleMap: Record<string, ModuleName> = {
    "/invoices/create": "invoices",
    "/invoices/createFreeform": "invoices",
  };

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const SubscriptionRouteGuard: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const pathname = location.pathname;
  const module = routeModuleMap[pathname];

  const { canUseModule, triggerSubscriptionModal } = useSubscription();

  useEffect(() => {
    if (module) {
      const { allowed } = canUseModule(module);
      if (!allowed) {
        triggerSubscriptionModal(module);
      }
    }
  }, [pathname]);

  const access = module ? canUseModule(module).allowed : true;

  // You can either show nothing, redirect, or return null
  if (module && !access) {
    return null; // OR <Navigate to="/upgrade" /> to redirect
  }

  return <>{children}</>;
};

export default SubscriptionRouteGuard;
